import { useState } from 'react';
import {
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Popover,
} from '@mui/material';
import CNFlag from '@stack/assets/images/flags/china.png';
import ENFlag from '@stack/assets/images/flags/united-kingdom.png';
import { StaticImageData } from 'next/image';
import setLanguage from 'next-translate/setLanguage';
// import useTranslation from 'next-translate/useTranslation';

type LanguageItem = {
  label: string;
  value: string;
  logo: StaticImageData | string;
};

const languages: Record<string, LanguageItem> = {
  en: {
    label: 'English',
    value: 'en',
    logo: ENFlag,
  },
  'zh-cn': {
    label: '中文',
    value: 'zh-cn',
    logo: CNFlag,
  },
};

export const LanguagePicker: React.FC = () => {
  // ======================= HOOKS
  // const { lang } = useTranslation();

  // ======================= STATE
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  // ======================= EVENTS
  const onHandleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onHandleClose = () => {
    setAnchorEl(null);
  };

  // ======================= VARIABLES
  const open = Boolean(anchorEl);
  const id = open ? 'language-popover' : undefined;

  // ======================= VIEWS
  return (
    <>
      <IconButton onClick={onHandleClick} sx={{ padding: 0 }}>
        {/* <Avatar
          alt="user-avatar"
          src={languages[lang as keyof typeof languages]?.logo.src}
          sx={{ width: 24, height: 24 }}
        /> */}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onHandleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <List>
          {Object.keys(languages).map((e: string) => {
            return (
              <div key={languages[e].value}>
                <ListItemButton
                  key={languages[e].value}
                  onClick={async () => {
                    onHandleClose();
                    await setLanguage(languages[e].value);
                  }}
                >
                  <ListItemText
                    primary={languages[e].label}
                    primaryTypographyProps={{
                      sx: { fontSize: 14 },
                    }}
                  />
                </ListItemButton>
              </div>
            );
          })}
        </List>
      </Popover>
    </>
  );
};

// ======================= EXPORT
export default LanguagePicker;
